import { render, staticRenderFns } from "./editdyx.vue?vue&type=template&id=1944389d"
import script from "./editdyx.vue?vue&type=script&lang=js"
export * from "./editdyx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1944389d')) {
      api.createRecord('1944389d', component.options)
    } else {
      api.reload('1944389d', component.options)
    }
    module.hot.accept("./editdyx.vue?vue&type=template&id=1944389d", function () {
      api.rerender('1944389d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dyxmanager/dyxDisGroup/editdyx.vue"
export default component.exports